import React from "react";
import { Switch } from "react-router-dom";

// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";
import ProtectedRoutes from "views/ProtectedRoutes";

// views

import Dashboard from "views/admin/Dashboard.js";
import Rutas from "views/admin/ProyeccionProd.js";
import Catalogos from "views/admin/Catalogos";
import Pronosticos from "views/admin/Pronosticos";


export default function Admin() {
  
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <Switch>
            <ProtectedRoutes path="/" exact component={Dashboard} />
            <ProtectedRoutes path="/proyeccion-produccion" component={Rutas} />
            <ProtectedRoutes path="/pronosticos" component={Pronosticos} />
            <ProtectedRoutes path="/catalogos" component={Catalogos} />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
